import ContentLayout from "../components/UI/Layout/ContentLayout";
import PageLayout from "../components/UI/Layout/PageLayout";
import HeaderLayout from "../components/UI/Layout/HeaderLayout";
import ParrainageShow from "../components/Account/ParrainageShow";

export default function ParrainagePage() {
  return (
    <PageLayout isBailleur>
      <ContentLayout
        header={
          <HeaderLayout
            title="Parrainage"
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Parrainage" },
            ]}
          />
        }
        body={
          <div className="content">
            <ParrainageShow />
          </div>
        }
      />
    </PageLayout>
  );
}
